<template>
  <div class="pt-6 grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-5">
    <div class="px-4 sm:px-0 relative">
      <div>
        <h2 class="text-base font-semibold leading-7 text-gray-900">Actions</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Enable Actions to allow Bot offering actions to user, such as book a meeting or visit a link.</p>
      </div>
    </div>
    <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
      <div class="px-4 py-2">
        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
          <ToggleGroup class="col-span-full" v-model="actionsEnabled" :name="propsDefs['actionsEnabled'].title" :description="propsDefs['actionsEnabled'].description">
            <div class="mt-2 pl-4 col-span-full border-l-2 border-indigo-100">
              <StdPropArrayEditor class="col-span-full" v-model="actions" :label="propsDefs['actions'].title" :description="propsDefs['actions'].description" :propertiesSpec="actionsSpecProps"></StdPropArrayEditor>
            </div>
          </ToggleGroup>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import InputTextarea from '@/components/Bots/editors/InputTextarea.vue';
  import ToggleGroup from '@/components/Toggles/ToggleGroup.vue';
  import CategoriesSelector from '@/components/Selectors/CategoriesSelector.vue';
  import { BOT_TYPE_DEFS, standardBotPropsByName } from '@/spec/BotTypeDefs';
  import { useBotsStore } from '@/store/BotsStore';
  import { computed } from 'vue';
  import StdPropArrayEditor from '@/components/Editors/StdPropArrayEditor.vue';
  import { getUUID } from '@enegelai/core';

  const botsStore = useBotsStore();

  const propsDefs = standardBotPropsByName;

  const actionsSpecProps = [
    // Always generate id for action
    { name: 'id', type: 'string', title: 'ID', hidden: true, default: () => getUUID() },

    //{ name: 'type', type: 'select', title: 'Type', description: 'Select type of action', options: ['Link', 'Calendly Meeting', 'Hubspot Meeting'], values: ['Link', 'Meeting', 'hubspotMeeting'], default: 'Link' },
    { name: 'type', type: 'selectLong', title: 'Type', description: 'Select type of action', options: ['Link', 'Calendly Meeting'], values: ['link', 'calendlyMeeting'], default: 'link' },
    //{ name: 'leadCondition', type: 'select', title: 'Show to Lead', options: ['Any', 'Hot'], default: 'Any' },

    // todo Intent condition - after detecting intent is in place, show actions for specific intent

    { name: 'conditionType', type: 'select', title: 'When to show', description: 'Select when to show action', options: ['Always', 'When Tags are set'], values: ['always', 'tags'], default: 'always' },
    { name: 'tagsValue', type: 'string', title: 'Tags', description: 'List of tags (comma-separated)', default: '', when: (i) => i.conditionType === 'tags' },

    { name: 'name', type: 'stringLong', title: 'Name', default: '' },
    { name: 'value', type: 'stringLong', title: 'URL', default: '' },
    { name: 'hubspotMeetingAuto', type: 'boolean', title: 'Open Booking Widget Automatically', default: false, when: (i) => i.type === 'hubspotMeeting' },

    // forceHandoff if meeting is booked - calendly / hubspot only. Email Handoff only
    { name: 'handoffOnMeetingBooked', type: 'boolean', title: 'Handoff when meeting is booked', default: false, when: (i) => i.type === 'calendlyMeeting' },
  ];

  const actionsEnabled = computed(botsStore.getPropGetSet('actionsEnabled'));
  const actions = computed(botsStore.getPropGetSet('actions'));
</script>
